// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedJob: null,
  availableUsers: []
}

const jobs = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_JOBS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ADD_JOB':
      return { ...state }
    case 'DELETE_JOB':
      return { ...state }
    case 'ADD_USER_COMPANY':
      return { ...state }
    case 'DELETE_USER_COMPANY':
      return { ...state }
    case 'GET_JOB':
      return { ...state, selectedJob: action.selectedJob }
    case 'EDIT_JOB':
      return { ...state }
    case 'GET_AVAILABLE_USERS':
      return { ...state, availableUsers: action.availableUsers }
    default:
      return { ...state }
  }
}
export default jobs
